import { render, staticRenderFns } from "./AdminSecurityAuthSetting.vue?vue&type=template&id=b5ab7e0e&"
import script from "./AdminSecurityAuthSetting.vue?vue&type=script&lang=ts&"
export * from "./AdminSecurityAuthSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports